import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../../Config";

const ConfirmMessageModal = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [Type, setType] = useState("");
  const [IsAccept, setIsAccept] = useState(true);

  useEffect(() => {
    if (props.RequestedItem.position) {
      setItemDetails(props.RequestedItem.position);
      setType("job");
    } else if (props.RequestedItem.project) {
      setItemDetails(props.RequestedItem.project);
      setType("project");
    } else {
      setItemDetails(props.RequestedItem.activity);
      setType("activity");
    }

    if (props.Decision === "REJECT" || props.Decision === "CANCEL") {
      setIsAccept(false);
    } else {
      setIsAccept(true);
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 30) {
        return Title;
      } else {
        return Title.slice(0, 26) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 40) {
        return Title;
      } else {
        return Title.slice(0, 36) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.title.length < 24) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.title.length < 35) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.title.length < 45) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    }
  };
  const accept = () => {
    let BaseURL;
    let JPAtype;
    if (Type === "job") {
      BaseURL = Config.PositionServiceURL;
    } else if (Type === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else {
      BaseURL = Config.ActivityServiceURL;
    }
    if (Type === "job") {
      JPAtype = "position";
    } else if (Type === "project") {
      JPAtype = "project";
    } else {
      JPAtype = "activity";
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAtype +
        "/application/reveal-identity",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        recommendationId: props.RequestedItem.id,
      },
    };
    if (props.MoreLikeThisIsActive) {
      Req.data.recommendationId = props.RequestedItem.recommendationId;
    }
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.ToggleChatRoom();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  return (
    <React.Fragment>
      <div className="cancel-verification-modal-overlay">
        <div className="outline" onClick={() => props.CloseModal()}></div>
        <div className="verification-modal verify-interview">
          <section className="modal-head">
            {ItemDetails === undefined ? null : (
              <span>
                <h1>{shortenTitle(ItemDetails.title)}</h1>
                {handleDisplayPopup()}
                <p>{ItemDetails.workCity}</p>
              </span>
            )}
            <i onClick={() => props.CloseModal()} className="feather-x"></i>
          </section>
          <section className="modal-body">
            <h1>
              Please note that by accepting this, your identity and contact
              information will be shared with the Hiring Manager and Recruiter.
            </h1>
          </section>
          <section className="modal-actions interview-actions">
            <button onClick={() => props.CloseModal()}>
              {translateText("cancel")}
            </button>
            <button className="accept-interview" onClick={() => accept()}>
              Accept
            </button>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConfirmMessageModal;
